import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, Block } from 'suomifi-ui-components';

export const VersionMismatchWarning = () => {
  const [showAlert, setShowAlert] = useState(true);
  if (showAlert) {
    return (
      <Block my="s">
        <Alert
          status="warning"
          closeText={<FormattedMessage id="intermediary.common.close" />}
          onCloseButtonClick={() => setShowAlert(false)}
        >
          <FormattedMessage id="intermediary.common.versionMismatchTitle" />
          <br />
          <FormattedMessage id="intermediary.common.versionMismatchExplanation" />
        </Alert>
      </Block>
    );
  } else {
    return null;
  }
};
